import ComponentInitializers from 'components/shared/ComponentInitializers/ComponentInitializers';
import ShowMoreContent from 'shared/show_more_content';
import CommentVideoSection from 'shared/components/comment_video_section';

export default class ShowMoreComments {
  init(containerSelector, commentsListSelector, linkContainerSelector) {
    let video = window.kmklabs.video;

    this.commentsListSelector = commentsListSelector;
    this.notEligibleToComment = (video && video.premium == "true" && video.source == false)
    $(document).on('click', containerSelector + ' ' + linkContainerSelector + ' :first-child', this.getMoreComments.bind(this));
  }

  get commentDisplayPerShow() {
    return 10;
  }

  getMoreComments(event) {
    event.preventDefault();
    let $target = $(event.target);

    let video_id = $target.data('video-id');
    let last_comment_id = $target.data('last-comment-id');
    let order = $target.data('order');
    let offset = $target.data('offset');
    let params = { 'video_id': video_id, last_comment_id: last_comment_id};

    if (order == 'newest') {
      params = {'video_id': video_id, count: this.commentDisplayPerShow, offset: offset, order: 'newest', last_comment_id: last_comment_id};
    }

    if (order == 'like') {
      params = {'video_id': video_id, count: this.commentDisplayPerShow, offset: offset, order: 'like', last_comment_id: last_comment_id};
    }

    $.get('/comments.html', params).always(function(data) {
      this.appendComments($target.parent(), data);

      if (this.notEligibleToComment) {
        CommentVideoSection.hideReplyButton();
      }
    }.bind(this));
  }

  appendComments($targetContainer, data) {
    let commentContainer = $targetContainer.siblings(this.commentsListSelector);
    commentContainer.append(data);
    let last_comment_id = this.getLastCommentId();

    let showMore = $targetContainer.find(':first-child');
    showMore.data('last-comment-id', last_comment_id);
    showMore.data('offset', parseInt(showMore.data('offset')) + 10);
    let totalComments = parseInt($(".video-comments-count").text());
    let totalCurrentComments = $(".comments__list-item").length;

    if (($(data).length < this.commentDisplayPerShow) || ((totalComments > 3) && (totalComments <= totalCurrentComments))) {
      $targetContainer.hide();
    }
    $("span.publish-date").timeago();
    new ShowMoreContent('.js-comment-container', '.truncate .read-more-comment', '.hidden'); // comment content

    new ComponentInitializers();
  }

  getLastCommentId() {
    return $(this.commentsListSelector).children()
      .map(function(_unused, element) {
        return $(element).data("id");
      })
      .sort().splice(0)[0];
  }
}
